import { Component, OnInit } from '@angular/core';
import { EngagmentCountModel } from '../../../models/engagment-count.model';
import { OsmosisService } from '../../services/osmosis.service';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-engagement-count',
  templateUrl: './engagement-count.component.html',
  styleUrls: ['./engagement-count.component.scss'],
  imports: [CommonSharedModule],
  standalone: true
})
export class EngagementCountComponent implements OnInit {
  engagmentCount!: EngagmentCountModel;
  loading = true;

  constructor(private osm: OsmosisService) {}

  ngOnInit() {
    this.loading = true;
    this.osm.getEngagementCountRequiringAction().subscribe(engagmentCount => {
      this.engagmentCount = engagmentCount;
      this.loading = false;
    });
  }
}
